const ButtonLoader = ({ isSmall = false, isExtraSmall = false }) => {
  return (
    <div className={`button-loader ${isSmall ? 'small' : ''} ${isExtraSmall ? 'extra-small' : ''}`}></div>
  )
};

export default ButtonLoader;
